/* eslint-disable max-lines-per-function */
import * as React from "react";
import { useMutation } from "@apollo/client";
import logger from "services/logger";
import { useSnackbar } from "components/haven-design/snackbar";
import { logCall as logCallType, logCallVariables } from "types/gql-types";
import { LOG_CALL } from "../queries";
import styles from "../interestsActivities.module.css";

const outcomeOptions = [
  "No answer",
  "Not in service",
  "Left Voicemail",
  "Spoke to Applicant",
  "Spoke to Applicant's Representative",
  "Left message with someone else",
  "Other",
];

const reasonOptions = [
  "Calling about a vacancy",
  "Calling to schedule interview",
  "Calling to update information",
  "Other",
];

export const PhoneSubView: React.FC<{ interestId: string }> = (props) => {
  const [outcome, setOutcome] = React.useState("");
  const [reason, setReason] = React.useState("");
  const [note, setNote] = React.useState("");
  const [logCall] = useMutation<logCallType, logCallVariables>(LOG_CALL, {
    refetchQueries: ["activityFeed", "getActivityFeed"],
  });

  const { openSnackbar } = useSnackbar();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const prefix = reason ? `Reason: ${reason}. Outcome: ${outcome}` : `Outcome: ${outcome}`;

    if (!outcome) {
      openSnackbar({ message: "Please select an outcome", status: "error" });
      return;
    }

    logCall({
      variables: {
        interestId: props.interestId,
        reason,
        outcome,
        note: `${prefix}${note && ` - ${note}`}`,
      },
    })
      .then(() => {
        setOutcome("");
        setReason("");
        setNote("");
        openSnackbar({ message: "Call Logged", status: "success" });
      })
      .catch((err) => {
        openSnackbar({
          message: "Error logging call. Please contact support@havenconnect.com for help.",
          status: "error",
        });
        logger.sendError(err);
      });
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <select
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          style={{ marginRight: 25 }}
          className={styles.logCallSelect}
        >
          <option disabled value="">
            Select Reason
          </option>
          {reasonOptions.map((value, i) => (
            <option key={i} value={value}>
              {value}
            </option>
          ))}
        </select>

        <select
          value={outcome}
          onChange={(e) => setOutcome(e.target.value)}
          className={styles.logCallSelect}
        >
          <option disabled value="">
            Select Outcome *
          </option>
          {outcomeOptions.map((value, i) => (
            <option key={i} value={value}>
              {value}
            </option>
          ))}
        </select>

        <textarea
          placeholder="Recap your call..."
          value={note}
          onChange={(e) => setNote(e.target.value)}
          className="form-control"
          style={{ margin: "20px 0 20px", minHeight: 120 }}
        />

        <div className="text-right">
          <input type="submit" value="Log a Call" className="btn btn-primary" />
        </div>
      </form>
    </div>
  );
};
